/**
 * Black Friday product grids: "Încarcă mai multe" shows the next rows of products that are already in the page.
 * The CSS (written by the section) hides everything past the current batch; this file only moves to the next batch,
 * hides the button when nothing is left to show, keeps the keyboard focus on the first new product and updates the
 * "Afișezi 8 din 24" counter.
 */
(function () {
  function columns(row) {
    var cols = getComputedStyle(row).gridTemplateColumns;
    return cols && cols !== "none" ? cols.split(" ").length : 1;
  }

  function setup(root) {
    if (root._bfProds) return;
    root._bfProds = true;
    var row = root.querySelector(".bf-prods__row");
    var more = root.querySelector("[data-bf-more]");
    if (!row || !more) return;
    var rowsInitial = parseInt(root.dataset.rowsInitial, 10) || 2;
    var rowsInitialMobile = parseInt(root.dataset.rowsInitialMobile, 10) || rowsInitial;
    var rowsMore = parseInt(root.dataset.rowsMore, 10) || 2;

    function visibleCount() {
      var batch = parseInt(root.dataset.batch, 10) || 0;
      var cols = columns(row);
      // phones (2 columns) may start with a different number of rows
      var first = cols <= 2 ? rowsInitialMobile : rowsInitial;
      return (first + batch * rowsMore) * cols;
    }
    var count = root.querySelector("[data-bf-count]");
    var countText = count && count.querySelector("[data-bf-count-text]");
    var countBar = count && count.querySelector(".bf-prods__bar i");
    function refresh() {
      var total = row.children.length;
      var shown = Math.min(visibleCount(), total);
      more.hidden = shown >= total;
      if (count) {
        // Only worth saying while there is more to load.
        count.hidden = more.hidden;
        countText.textContent = count.dataset.text.replace("[x]", shown).replace("[y]", total);
        countBar.style.setProperty("--p", (shown / total).toFixed(3));
      }
    }

    more.addEventListener("click", function () {
      var before = visibleCount();
      root.dataset.batch = String((parseInt(root.dataset.batch, 10) || 0) + 1);
      refresh();
      var firstNew = row.children[before];
      var link = firstNew && firstNew.querySelector("a");
      if (link) link.focus({ preventScroll: true });
    });
    window.addEventListener("resize", refresh);
    refresh();
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-bf-prods]"), setup);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll("[data-bf-prods]"), setup);
  });
})();
